"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "dego": {
    "ffc26847": [{
      "hkey": "bb1c0f01",
      "slug": "brovida",
      "name": "Brovida",
      "primary": true,
      "skipSearch": false
    }],
    "brovida-chiesa": [{
      "hkey": "bb1c0f01",
      "slug": "brovida",
      "name": "Brovida",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "29e7552e": [{
      "hkey": "c46b7f4c",
      "slug": "girini-governatori-saraffi",
      "name": "Girini-Governatori-Saraffi",
      "primary": true,
      "skipSearch": false
    }],
    "girini": [{
      "hkey": "c46b7f4c",
      "slug": "girini-governatori-saraffi",
      "name": "Girini-Governatori-Saraffi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "dego"
    }],
    "28a1a734": [{
      "hkey": "c46b7f4c",
      "slug": "girini-governatori-saraffi",
      "name": "Girini-Governatori-Saraffi",
      "primary": true,
      "skipSearch": false
    }],
    "governatori": [{
      "hkey": "c46b7f4c",
      "slug": "girini-governatori-saraffi",
      "name": "Girini-Governatori-Saraffi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "dego"
    }],
    "b340a9e1": [{
      "hkey": "65a97d8b",
      "slug": "dego",
      "name": "Dego",
      "primary": true,
      "skipSearch": false
    }],
    "niosa": [{
      "hkey": "65a97d8b",
      "slug": "dego",
      "name": "Dego",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f0a10bd8": [{
      "hkey": "c46b7f4c",
      "slug": "girini-governatori-saraffi",
      "name": "Girini-Governatori-Saraffi",
      "primary": true,
      "skipSearch": false
    }],
    "saraffi": [{
      "hkey": "c46b7f4c",
      "slug": "girini-governatori-saraffi",
      "name": "Girini-Governatori-Saraffi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "dego"
    }]
  }
};
exports["default"] = _default;